export default __webpack_public_path__ + "static/media/ukchartslogo.2125369d.png";